module.exports = __webpack_public_path__ + "media/news/berlin-news-03-fc652159.webp";